// =============================================================
//  Configuración central del API
// -------------------------------------------------------------
//  La URL base cambia AUTOMÁTICAMENTE según el entorno gracias a
//  las variables de entorno de Create React App:
//
//    • npm start      -> usa .env.development  (http://localhost:8080)
//    • npm run build  -> usa .env.production   (https://api.srv1070869.hstgr.cloud)
//
//  Ya NO hay que comentar/descomentar URLs en cada servicio.
//  El valor por defecto apunta a PRODUCCIÓN: si por algún motivo
//  la variable no estuviera definida, el sistema sigue funcionando
//  igual que hoy (contra producción).
// =============================================================
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://api.srv1070869.hstgr.cloud";

export default API_BASE_URL;
